/* eslint-disable */
/**
 * Muse audit C1 (2026-10-21, Public Look re-walk): "covers nothing" means no
 * visible content at all, not only links, buttons and inputs. Returns viewport
 * boxes for painted text (Range.getClientRects), images, svg/chart labels,
 * canvas, video, iframes, form controls and interactive elements. A box counts
 * only when actually painted: not opacity 0 (itself or an ancestor), not
 * visibility hidden, clipped to its overflow ancestors (dropped if clipped
 * away), and on top at its center per elementFromPoint (Sarah's own UI does
 * not count as cover). Text and controls are strict (any overlap blocks);
 * media use the large-surface share rule in launcherBlocks.
 *
 * Plain-JS body on purpose: the look-pass covers script transpiles and injects
 * this exact file, so the check and the launcher share one definition.
 * `bands` limits work to regions the launcher can occupy (null = viewport).
 */
export function sarahPaintedRects(doc: any, exclude: any, bands: any): any[] {
  var view = doc.defaultView
  var vw = view.innerWidth, vh = view.innerHeight
  var out: any[] = []
  var STRICT = 'a[href],button,input,select,textarea,summary,[role="button"],[role="link"],[role="radio"],[role="checkbox"],[role="switch"],[role="slider"],[role="tab"],[tabindex]:not([tabindex="-1"]),[contenteditable="true"]'
  var MEDIA = 'img,svg,canvas,video,iframe'
  function inBands(b: any) {
    if (b.right <= 0 || b.left >= vw || b.bottom <= 0 || b.top >= vh) return false
    if (!bands) return true
    for (var i = 0; i < bands.length; i++) {
      var k = bands[i]
      if (b.left < k.right && b.right > k.left && b.top < k.bottom && b.bottom > k.top) return true
    }
    return false
  }
  function clipAndShow(el: any, b: any) {
    for (var n = el; n && n !== doc.documentElement; n = n.parentElement) {
      var st = view.getComputedStyle(n)
      if (Number(st.opacity) === 0) return null
      if (n === el && (st.visibility === 'hidden' || st.visibility === 'collapse')) return null
      if (n !== el && /(hidden|clip|scroll|auto)/.test(st.overflow + st.overflowX + st.overflowY)) {
        var c = n.getBoundingClientRect()
        if (c.width > 0 || c.height > 0) {
          b = { left: Math.max(b.left, c.left), top: Math.max(b.top, c.top), right: Math.min(b.right, c.right), bottom: Math.min(b.bottom, c.bottom) }
          if (b.right - b.left < 1 || b.bottom - b.top < 1) return null
        }
      }
    }
    return b
  }
  function onTop(el: any, b: any) {
    if (typeof doc.elementFromPoint !== 'function') return true
    var cx = (Math.max(0, b.left) + Math.min(vw, b.right)) / 2
    var cy = (Math.max(0, b.top) + Math.min(vh, b.bottom)) / 2
    var hit = doc.elementFromPoint(cx, cy)
    if (!hit) return true
    if (exclude && exclude.contains(hit)) return true
    return hit === el || el.contains(hit) || hit.contains(el)
  }
  function add(el: any, r: any, strict: boolean, kind: string) {
    var b: any = { left: r.left, top: r.top, right: r.right, bottom: r.bottom }
    if (b.right - b.left < 1 || b.bottom - b.top < 1 || !inBands(b)) return
    b = clipAndShow(el, b)
    if (!b || !inBands(b) || !onTop(el, b)) return
    b.strict = strict
    b.kind = kind
    out.push(b)
  }
  var els = doc.querySelectorAll(STRICT + ',' + MEDIA)
  for (var i = 0; i < els.length; i++) {
    var el = els[i]
    if (exclude && exclude.contains(el)) continue
    if (el.closest('[hidden],[inert],[aria-hidden="true"] svg *')) continue
    if (el.ownerSVGElement) continue
    var strict = el.matches(STRICT) && !el.matches(MEDIA)
    add(el, el.getBoundingClientRect(), strict, strict ? 'control' : 'media')
  }
  var walker = doc.createTreeWalker(doc.body, 4)
  var range = doc.createRange()
  for (var t = walker.nextNode(); t; t = walker.nextNode()) {
    if (!/\S/.test(t.nodeValue || '')) continue
    var p = t.parentElement
    if (!p || (exclude && exclude.contains(p)) || p.closest('script,style,noscript,template,[hidden],[inert]')) continue
    range.selectNodeContents(t)
    if (typeof range.getClientRects !== 'function') continue
    var rects = range.getClientRects()
    for (var j = 0; j < rects.length; j++) add(p, rects[j], true, 'text')
  }
  return out
}
